<template>
  <v-data-table
    :headers="headers"
    :items="collapsedItems"
    dense hide-default-footer disable-sort
    mobile-breakpoint="0"
    class="statement-items"
  >
    <template #item.price_cents="{ item }">
      {{ formatCurrency(item.price_cents) }}
    </template>

    <template #item.subtotal_cents="{ item }">
      {{ formatCurrency(item.subtotal_cents) }}
    </template>
  </v-data-table> 
</template>

<script>
import formatters from '@/lib/formatters'

export default {
  name: 'StatementItems',

  props: {
    statement_items: {
      type: Array,
      required: true,
    },
  },

  computed: {
    collapsedItems() {
      let rval = []
      this.statement_items.forEach( item => {
        let found = rval.find( 
          row => row.description === item.description && 
                 row.price_cents === item.price_cents &&
                 row.taxable === item.taxable
        )
        if (found) {
          found.quantity += item.quantity
          found.subtotal_cents += item.subtotal_cents
          found.tax_cents += item.tax_cents
          found.total_cents += item.total_cents
        } else {
          rval.push({...item})
        }
      })

      return rval
    },
  },

  data() {
    return {
      headers: [
        { text: 'Description', value: 'description', class: "px-1", cellClass: "px-1" },
        { text: 'Qty.', value: 'quantity', align: 'end', class: "px-1", cellClass: "px-1" },
        { text: 'Price', value: 'price_cents', align: 'end', class: "px-1", cellClass: "px-1 nowrap" },
        { text: 'Total', value: 'subtotal_cents', align: 'end', class: "px-1", cellClass: "px-1 nowrap" },
      ],
    }
  },

  methods: {
    ...formatters,
  }
}
</script>

<style>
  .statement-items > .v-data-table__wrapper > table > thead > tr > th {
    font-size: 12px !important;
    color: black !important;
    height: 24px !important;
  }

  .statement-items > .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 12px !important;
    color: rgb(0,0,0,0.6) !important;
    height: 24px !important;
    border-bottom: none !important;
  }

  .statement-items > .v-data-table__wrapper > table > tbody > tr > td.nowrap {
    white-space: nowrap;
  }
  
</style>